module.exports = __webpack_public_path__ + "media/_/_/node_modules/gateway_web_console/app/assets/images/light_pink_theme-765285469026369a876a280b2dd00e9e.png";